import useTypedContext from "hooks/useTypedContext";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { ContextContext } from "../../Context";
import { ContextVariablesListItemDropdownProps } from "./types";
import { showDeleteVariableConfirmation } from "./DeleteVariableConfirmation";

const ContextVariablesListItemDropdown = ({
  item,
  onEdit,
}: ContextVariablesListItemDropdownProps) => {
  const { context, canUpdateContext } = useTypedContext(ContextContext);

  const handleEditConfig = () => {
    onEdit(item);
  };

  const handleDeleteVariable = () => {
    showDeleteVariableConfirmation({ id: item.id, contextId: context.id });
  };

  return (
    <DropdownMenuEllipsis tooltip="Variable actions">
      <DropdownMenuItem
        onAction={handleEditConfig}
        isDisabled={!canUpdateContext.result}
        tooltip={canUpdateContext.message}
      >
        Edit
      </DropdownMenuItem>

      <DropdownMenuItem
        danger
        onAction={handleDeleteVariable}
        isDisabled={!canUpdateContext.result}
        tooltip={canUpdateContext.message}
      >
        Delete
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default ContextVariablesListItemDropdown;
